import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // Dejar que el navegador ponga el boundary en multipart
  if (typeof FormData !== "undefined" && cfg.data instanceof FormData) {
    delete cfg.headers["Content-Type"];
  }
  return cfg;
});

const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && !NO_RETRY.some((u) => orig.url.includes(u))) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const { data } = await refreshing;
        localStorage.setItem("token", data.access_token);
        return api(orig);
      } catch (e) {
        localStorage.removeItem("token");
      } finally {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return "Algo ha fallado. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return detail.msg || String(detail);
}

export const fmtDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("es-ES", { day: "numeric", month: "short" });
export const fmtGrams = (g) => (g >= 1000 ? `${(g / 1000).toFixed(1).replace(".0", "")} kg` : `${g} g`);

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const postStream = (path, body) => {
  const t = localStorage.getItem("token");
  return fetch(`${BASE}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(t ? { Authorization: `Bearer ${t}` } : {}) },
    body: JSON.stringify(body),
  });
};

export async function streamCoach(message, onEvent) {
  let res = await postStream("/coach/chat", { message });
  if (res.status === 401) {
    const { data } = await api.post("/auth/refresh");
    localStorage.setItem("token", data.access_token);
    res = await postStream("/coach/chat", { message });
  }
  if (!res.ok) throw new Error("No se pudo contactar con el coach");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const chunk = buf.slice(0, i).trim();
      buf = buf.slice(i + 2);
      if (chunk.startsWith("data:")) onEvent(JSON.parse(chunk.slice(5)));
    }
  }
}
